var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstallMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.46 198c-3.64 0-6.73-1.3-9.27-3.88a12.93 12.93 0 0 1-3.82-9.42V16.3c0-3.7 1.28-6.84 3.82-9.42A12.52 12.52 0 0 1 40.46 3h69.77v33.24H40.46v128.52h95.94v-28.8h13.08v48.74c0 3.7-1.27 6.84-3.82 9.42a12.52 12.52 0 0 1-9.26 3.88H40.46Zm103.35-85.76a8.2 8.2 0 0 1-2.4-.33 5.32 5.32 0 0 1-2.18-1.44l-31.4-31.9a6.43 6.43 0 0 1-1.96-4.66c0-1.77.65-3.32 1.96-4.65a5.85 5.85 0 0 1 4.58-1.89c1.75.08 3.27.7 4.58 1.89l20.28 20.38V29.6c0-1.92.62-3.5 1.85-4.76a6.3 6.3 0 0 1 4.69-1.89 6.3 6.3 0 0 1 4.69 1.89 6.51 6.51 0 0 1 1.85 4.76v60.05l20.28-20.38a7.09 7.09 0 0 1 4.58-1.89 5.85 5.85 0 0 1 4.58 1.89 6.43 6.43 0 0 1 1.96 4.65c0 1.77-.65 3.32-1.96 4.65l-31.4 31.91a5.32 5.32 0 0 1-2.18 1.44 8.2 8.2 0 0 1-2.4.33Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallMobile);
export default __webpack_public_path__ + "assets/media/install-mobile.d965b123.svg";
export { ForwardRef as ReactComponent };